var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGmapsMarker(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FF0",
    fillOpacity: 0.7,
    d: "M6.56 5A1.563 1.563 0 0 1 5 6.56 1.563 1.563 0 0 1 3.44 5a1.56 1.56 0 0 1 3.12 0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGmapsMarker);
export default __webpack_public_path__ + "static/media/gmaps-marker.c560707b23be9c83edfd46009170e6a7.svg";
export { ForwardRef as ReactComponent };